import { useOutletContext } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";

import { IntegrationsOutletContext } from "../types";

const IntegrationDetails = () => {
  const { integration } = useOutletContext<IntegrationsOutletContext>();

  if (!integration?.hasViewScreen || !integration.detailsPage) {
    return <NotFoundPage />;
  }

  const DetailsPage = integration.detailsPage;
  return <DetailsPage />;
};

export default IntegrationDetails;
